// ── usePolyAccount — Auto-connect lifecycle hook ────────────────
// Mirrors useKalshiAccount pattern. On mount, checks localStorage
// for saved config and connects if found. Disconnects on unmount.

import { useEffect } from 'react';
import { usePolyAccountStore, autoConnectPoly } from '../stores/polyAccountStore';

export function usePolyAccount(): void {
  useEffect(() => {
    autoConnectPoly();

    return () => {
      usePolyAccountStore.getState().disconnect();
    };
  }, []);
}
